var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1108_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.26038H4.99998C4.55795 2.26038 4.13403 2.43597 3.82147 2.74853C3.50891 3.06109 3.33331 3.48502 3.33331 3.92704V17.2604C3.33331 17.7024 3.50891 18.1263 3.82147 18.4389C4.13403 18.7514 4.55795 18.927 4.99998 18.927H15C15.442 18.927 15.8659 18.7514 16.1785 18.4389C16.4911 18.1263 16.6666 17.7024 16.6666 17.2604V8.09371L10.8333 2.26038Z",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 2.26038V8.09371H16.6666",
    stroke: "#98BDBD",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1108_571"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(20 0.59375) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIc);
export default __webpack_public_path__ + "static/media/document_ic.fb234cd034552368e22a78a16f4030a5.svg";
export { ForwardRef as ReactComponent };